import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Route } from 'react-router-dom';

// Import components
import Home from './components/Home';
import Resume from './components/Resume';
import ResumePrint from './components/ResumePrint';

// Initialize the app after DOM is loaded
document.addEventListener("DOMContentLoaded", function () {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/resume',
      element: <Resume />
    },
    {
      path: '/resume-print',
      element: <ResumePrint />
    },
    {
      path: '*',
      element: <Resume />
    }
  ]);

  const container = document.getElementById('container');
  const root = createRoot(container);
  
  root.render(
    <React.StrictMode>
      <RouterProvider router={router} />
    </React.StrictMode>
  );
});
